import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";

import ChatbotLayout from "../../chatbot/shared/ChatbotLayout";
import Message from "../../../i18n/Message";
import { CableIcon, PlusIcon } from "lucide-react";
import Spinner from "../../../assets/icons/Spinner";
import ZeroState from "../../chatbot/shared/ZeroState";

import "./McpServersPage.scss";
import CreateMcpServerDialog from "./CreateMcpServerDialog";
import McpServerTile from "./McpServerTile";
import { mcpServerSelectors } from "../store/mcpServerReducer";
import { loadPublicMcpServers } from "../store/mcpServerActionCreators";

const McpServersPage = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const servers = useSelector(mcpServerSelectors.getPublicServers);
  const [showCreate, setShowCreate] = useState(false);

  useEffect(() => {
    if (!servers) {
      dispatch(loadPublicMcpServers(intl));
    }
  }, [servers, intl, dispatch]);

  return (
    <ChatbotLayout contentPanelClassName="mcp_servers_page">
      <div className="breadcrumbs">&nbsp;</div>
      <h1 className="servers_title">
        <Message id="mcp_servers_title" />
      </h1>
      {/*<div className="actions_panel">
        <button
          className="btn bg-gradient-primary"
          onClick={() => setShowCreate(true)}
        >
          <PlusIcon size="18" color="#fff" />
          <Message id="create_chatbot" />
        </button>
      </div>*/}
      <div className="body_content">
        <div className="content_header">
          <div></div>
        </div>
        <div className="campaign_tiles mcp_tiles_list">
          {!servers && <Spinner />}
          {servers && servers.length === 0 && (
            <div className="zero_state_container">
              <ZeroState
                icon={<CableIcon color="#67748e" size="36" />}
                textKey="chatbot_list_zero_state_text"
                buttonKey="chatbot_list_zero_state_button"
                onClick={() => setShowCreate(true)}
              />
            </div>
          )}
          {servers &&
            servers.map((item) => (
              <McpServerTile key={item.uid} server={item} />
            ))}
        </div>
      </div>
      {showCreate && (
        <CreateMcpServerDialog onClose={() => setShowCreate(false)} />
      )}
    </ChatbotLayout>
  );
};

export default McpServersPage;
